<ui-input-wrapper
  [label]="base.label"
  [labelTemplate]="base.labelTemplate"
  [extendedHelpTooltip]="base.extendedHelpTooltip()"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [hintTemplate]="base.hintTemplate"
  [hint]="base.hint"
  [maxLength]="text.maxLength"
  [errors]="control.errors"
  [submitted]="submitted"
  [forceShowValidationErrors]="base.forceShowValidationErrors()"
  [errorLabels]="base.errorLabels()"
  [valueLength]="nativeInputElement.value.length"
  [control]="control"
  [randomInputId]="randomInputId">
  <input
    pInputText
    class="__input"
    #nativeInputElement
    [formControl]="$any(control)"
    [type]="textInput.type()"
    [style.paddingRight]="paddingRight"
    [readonly]="base.readonly()"
    (blur)="textInput.handleBlur.emit()"
    [attr.maxlength]="text.maxLength"
    [attr.placeholder]="base.placeholder !== null ? base.placeholder : base.label"
    [attr.name]="base.name()"
    (input)="text.valueChange.emit($any($event.currentTarget).value)"
    [id]="randomInputId" />
  <!-- create text-form-control-append-area -->
  @if (text.appendText || text.appendIcon || dropdown.clearable) {
    <span class="absolute top-0 right-4 flex h-10 items-center">
      @if (dropdown.clearable && nativeInputElement.value.length) {
        <span pTooltip="Vymazat obsah pole" (click)="control.reset(); dropdown.clear.emit()" class="__clear-input">
        </span>
      }
      @if (text.appendText) {
        <span class="__append-text">
          {{ text.appendText }}
        </span>
      }
      @if (text.appendIcon) {
        <span class="__append-icon">
          <i [ngClass]="text.appendIcon"></i>
        </span>
      }
    </span>
  }
</ui-input-wrapper>
